import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { SearchkitComponent, FastClick } from "../../../../core";
export var TagFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(TagFilter, _SearchkitComponent);

  function TagFilter() {
    var _this;

    _classCallCheck(this, TagFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagFilter).call(this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TagFilter, [{
    key: "isActive",
    value: function isActive() {
      var _this$props = this.props,
          field = _this$props.field,
          value = _this$props.value;
      var accessor = this.searchkit.accessors.statefulAccessors[field];

      if (!accessor) {
        console.warn('Missing accessor for', field, 'in TagFilter, add TagFilterConfig if needed');
        return false;
      }

      return accessor.state.contains(value);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props2 = this.props,
          field = _this$props2.field,
          value = _this$props2.value;
      var accessor = this.searchkit.accessors.statefulAccessors[field];

      if (!accessor) {
        console.error('Missing accessor for', field, 'in TagFilter, add TagFilterConfig if needed');
        return;
      }

      accessor.state = accessor.state.toggle(value);
      this.searchkit.performSearch();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          children = _this$props3.children;
      var className = "sk-tag-filter";
      if (this.isActive()) className += " is-active";

      if (children) {
        return React.createElement(FastClick, {
          handler: this.handleClick
        }, React.createElement("div", {
          key: value,
          className: className
        }, this.props.children));
      } else {
        // No children, use the value instead
        return React.createElement(FastClick, {
          handler: this.handleClick
        }, React.createElement("div", {
          key: value,
          className: className
        }, value));
      }
    }
  }]);

  return TagFilter;
}(SearchkitComponent);